import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { TeamsService } from '@brafton/atlas-api-client';
import { People } from '@brafton/common-framework-library';
import { Observable } from 'rxjs';

@Component({
  selector: 'shared-filter-panel-teams',
  templateUrl: './filter-panel-teams.component.html',
  styleUrls: ['./filter-panel-teams.component.scss'],
  host: { class: 'shared-filter-panel-teams' },
})
export class SharedFilterPanelTeamsComponent implements OnInit {
  @Input() teams: Filter[] = [];
  @Output() teamsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();
  teams$!: Observable<People[]>;

  constructor(private teamsService: TeamsService) { }

  ngOnInit() {
    this.teams$ = this.teamsService.ListTeams(5);
  }

  add(team: People) {
    if (!this.teams.find((sp) => sp.value === team.id.toString())) {
      this.teams.push({ value: team.id, displayName: team.displayName, type: 'team' } as Filter);
    }
    this.teamsChange.emit(this.teams);
  }

  remove(team: People) {
    const index = this.teams.findIndex((sp) => sp.value === team.id.toString());
    if (index > -1) {
      this.teams.splice(index, 1);
    }
    this.teamsChange.emit(this.teams);
  }

  isSelected(team: People): boolean {
    if (!this.teams) return false;
    if (this.teams.find((sp) => sp.value === team.id.toString())) return true;
    else return false;
  }

  clear() {
    this.teams = [];
    this.teamsChange.emit(this.teams);
  }

}
